
const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.editor;
import { PanelBody } from '@wordpress/components';
import React, { useState, useEffect } from 'react';
import Parser from "html-react-parser";
import jQuery from "jquery";

//custom components
import Productid from "./controls/productid";
import RedirectProduct from "./controls/redirectproduct";


const { Component } = wp.element;

registerBlockType('migblocks/embed-product', {
    title: 'Gumroad Embed Product',
    icon: 'store',
    category: 'apijoin-gumroad',
    attributes: {
        productId: {
            type: "string",
            default: ""
        },
        redirectProduct: {
            type: "boolean",
            default: false
        },
    },



    edit: class extends Component {
        constructor(props) {
            super(props);

            this.myRef = React.createRef();

        }
        componentDidMount(props){
            /*
            let iframe = this.myRef.current;
            let id = iframe.getAttribute("id");

            iframe.height = "1000px"
            
            setTimeout(function(){
                let height = jQuery("#"+id).contents().height();
                console.log(height);
                
            }, 6000);
           */
        }

        componentDiUpdate(props){
            
        }


        render() {
           
      

            const { attributes: { productId, redirectProduct}, setAttributes } = this.props;

            let finalProductId = "";
            if(productId){
                finalProductId = productId.toLowerCase();
            }
            /*
            let content = "";

            
            content += `<div class="gumroad-product-embed" data-gumroad-product-id="${productId}" ${redirectCheck}`;
            content += `<a href={"https://gumroad.com/l/"${productId}>`;
            content += `Loading...`;
            content += `</a>`;
            content += `</div>`;
            */
            let origin = encodeURIComponent(window.origin);
            let outbound = "";
            if(redirectProduct == true){
                outbound = "&outbound_embed=true";
            }
            let iframeSrc = `https://gumroad.com/l/${productId}?null&&as_embed=true&referrer=&origin=${origin}${outbound}`;

            

            if(productId) {  
                return (
                    <React.Fragment>
                        <InspectorControls>
                            <PanelBody title={"Product Options"} initialOpen={true} >
                                
                                <Productid {...this.props}/>
                                <RedirectProduct {...this.props}/>
                                
                                
                            </PanelBody>
                        </InspectorControls>

                        <iframe ref={this.myRef} allowfullscreen="allowfullscreen" class="gumroad-embed-iframe" scrolling="no" width="100%"  id={"gumroad-embed-iframe-"+finalProductId}  src={iframeSrc}></iframe>
                    </React.Fragment> 
                

                );
            }
            
            return (
                <React.Fragment>
                        <InspectorControls>
                            <PanelBody title={"Product Options"} initialOpen={true} >
                                
                                <Productid {...this.props}/>
                                <RedirectProduct {...this.props}/>
                                
                                
                            </PanelBody>
                        </InspectorControls>

                        <h2 className="apijoin-nogumroad-id">
                            Insert a Product ID
                        </h2>
                        
                        
                    </React.Fragment> 
            );
              
           

        }
    },

    save: class extends Component {

        constructor(props) {
            super(props);

        }



        render() {
            const { attributes: { productId, redirectProduct}} = this.props;

           
            let finalProductId = "";
            if(productId){
                finalProductId = productId.toLowerCase();
            }
            /*

            let content = "";

            content += `<div class="gumroad-product-embed" data-gumroad-product-id="${productId}" ${redirectCheck}`;
            content += `<a href={"https://gumroad.com/l/"${productId}>`;
            content += `Loading...`;
            content += `</a>`;
            content += `</div>`;
            */

            let origin = encodeURIComponent(window.origin);
            let outbound = "";
            if(redirectProduct == true){
                outbound = "&outbound_embed=true";
            }
            let iframeSrc = `https://gumroad.com/l/${productId}?null&&as_embed=true&referrer=&origin=${origin}${outbound}`;

            return (

                

                <React.Fragment>
                    <iframe ref={this.myRef} allowfullscreen="allowfullscreen" class="gumroad-embed-iframe" scrolling="no" width="100%"  id={"gumroad-embed-iframe-"+finalProductId}  src={iframeSrc}></iframe>
                </React.Fragment> 
          

            );
        }





    }


});
